import type { RefOrGetter } from "ls/common/types";
import type { Router } from "vue-router";
import { toFileOverview } from "ls/router/builders";
import { objectParameterName } from "ls/router/constants";
import { toValue } from "vue";
import { useRouter } from "vue-router";
import { normalizeGuid } from "@/common/lib/string";

export function getFileRoute(router: Router, shortcut: string) {
  return router.resolve(toFileOverview(shortcut));
}

export function getObjectRoute(router: Router, shortcut: string, objectId: string) {
  return router.resolve(toFileOverview(shortcut, { object: objectId }));
}

export function getDocumentNodeRoute(router: Router, shortcut: string, nodeId: string) {
  return router.resolve(toFileOverview(shortcut, { node: nodeId }));
}

export function usePermalinks(shortcut: RefOrGetter<string>) {
  const router = useRouter();

  function getFilePermalink(shortcut: string) {
    const route = getFileRoute(router, shortcut);

    const relativePath = route.fullPath;
    const absoluteUrl = new URL(relativePath, globalThis.location.origin);
    return absoluteUrl.href;
  }

  function getObjectPermalink(objectId: string) {
    const route = getObjectRoute(router, toValue(shortcut), objectId);

    const relativePath = route.fullPath;
    const absoluteUrl = new URL(relativePath, globalThis.location.origin);
    return absoluteUrl.href;
  }

  function getDocumentNodePermalink(nodeId: string) {
    const route = getDocumentNodeRoute(router, toValue(shortcut), nodeId);

    const relativePath = route.href;
    const absoluteUrl = new URL(relativePath, globalThis.location.origin);
    return absoluteUrl.href;
  }

  return {
    getFilePermalink,
    getObjectPermalink,
    getDocumentNodePermalink,
  };
}

export function getObjectPermalinkWithoutRouter(shortcut: string, objectId: string) {
  // const url = new URL(`/app/${routeNames.filePreview}/${shortcut}`, window.location.origin);
  const url = new URL(`/app/project/${shortcut}`, window.location.origin);
  url.searchParams.append(objectParameterName, normalizeGuid(objectId));
  return url.toString();
}
